import { LoginStatuses } from '../../hooks/useBookLogin';
import client from './client';
import {
    IUserLog,
    IBookLog,
    IBookRegionLog,
    getRequestData,
    formatUserData,
} from './index';

export const logBookLoginSubmit = (
    cid: string,
    user: IUserLog,
    book: Omit<IBookLog, 'status'>,
    bookRegion: IBookRegionLog
) => {
    client.info('book login submit', {
        cid,
        context: 'hooks/useBookLogin',
        book,
        bookRegion,
        ...formatUserData(user),
        ...getRequestData(),
    });
};

export const logBookLoginResponse = (
    cid: string,
    user: IUserLog,
    book: Omit<IBookLog, 'status'>,
    bookRegion: IBookRegionLog,
    responseStatus: LoginStatuses,
    responseTime: number
) => {
    client.info('book login response', {
        cid,
        context: 'hooks/useBookLogin',
        book,
        bookRegion,
        ...formatUserData(user),
        ...getRequestData(),
        response: {
            status: responseStatus,
            timeElapsed: responseTime,
        },
    });
};
